var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fpc-nav-container" }, [
    _c(
      "ul",
      _vm._l(_vm.slidesItems, function (slide, index) {
        return _c(
          "li",
          {
            on: {
              mouseenter: function ($event) {
                return _vm.hoverItem(index)
              },
              mouseleave: function ($event) {
                return _vm.leaveItem(index)
              },
            },
          },
          [
            _c(
              "a",
              {
                class: {
                  active: _vm.activeSlideIndex === index,
                  hover:
                    _vm.activeHoverSlideIndex === index &&
                    _vm.itemHoveredOk === true,
                },
                attrs: { href: "#" + slide.anchor },
              },
              [
                _c("span", {
                  staticClass: "fp-sr-only",
                  domProps: { innerHTML: _vm._s(slide.name) },
                }),
                _vm._v(" "),
                _c("span"),
              ]
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fadeFP" } }, [
              _vm.checkShowTooltip(index)
                ? _c("div", {
                    staticClass: "fpc-tooltip",
                    domProps: { innerHTML: _vm._s(slide.name) },
                    on: {
                      click: function ($event) {
                        return _vm.goToSlide(index)
                      },
                    },
                  })
                : _vm._e(),
            ]),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }